import React, { useEffect, useRef, useState } from "react";
import { Tooltip } from "recharts";
import { IconWithBg } from "../../styles/styles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import styled from "styled-components";
import BackdropWrapper from "../modals/BackdropWrapper";
import ShareRecipe from "../modals/ShareRecipe";
import QuickAddRecipe from "../modals/QuickAddRecipe";
import { deleteDoc, doc } from "firebase/firestore";
import { auth, db } from "../../authentication/firebase";
import { useDispatch, useSelector } from "react-redux";
import { alertActions } from "../../store/alertSlice";
import { CircularProgress } from "@mui/material";
import { Avatar } from "antd";
import { useNavigate } from "react-router";
import { userActions } from "../../store/userSlice";

export default function ProfileDropdown({
  recipeData,
  servings,
  selectedDate,
  handleBackdrop,
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [shareBackdrop, setShareBackdrop] = useState(false);
  const [quickAddBackdrop, setQuickAddBackdrop] = useState(false);
  const [deleteRecipeLoading, setDeleteRecipeLoading] = useState(false);

  const boxRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { photoURL, email, displayName } = auth.currentUser;

  function iconClickHandler() {
    setMenuOpen((current) => !current);
  }
  const shareRecipeHandler = () => {
    setMenuOpen(false);
    setShareBackdrop((prev) => !prev);
  };
  const quickAddRecipeHandler = () => {
    setMenuOpen(false);
    setQuickAddBackdrop((prev) => !prev);
  };

  const logoutHandler = async () => {
    try {
      await auth.signOut();
      dispatch(
        userActions.setCurrentUser({
          fullname: "",
          email: "",
          uid: "",
          image: "",
          preferences: {},
        })
      );
      navigate("/login");
    } catch (e) {
      console.log("Logout error", e);
    }
  };

  const options = [
    { name: "Profile", clickHandler: () => navigate("/profile") },
    { name: "Saved Recipes", clickHandler: () => navigate("/favorites") },
    { name: "Logout", clickHandler: logoutHandler },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (boxRef.current && !boxRef.current.contains(event.target)) {
        // Clicked outside the box
        setMenuOpen(false);
      }
    };

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <StyledOptions>
      <BackdropWrapper
        smallSize={true}
        open={shareBackdrop}
        handleBackdrop={shareRecipeHandler}
        element={
          <ShareRecipe
            recipeData={recipeData}
            handleBackdrop={shareRecipeHandler}
          />
        }
      />
      <BackdropWrapper
        open={quickAddBackdrop}
        handleBackdrop={quickAddRecipeHandler}
        smallSize={true}
        element={
          <QuickAddRecipe
            data={recipeData}
            selectedServings={servings}
            handleBackdrop={quickAddRecipeHandler}
            selectedDate={selectedDate}
          />
        }
      />
      <div ref={boxRef}>
        <Avatar
          src={photoURL}
          onClick={iconClickHandler}
          style={{
            fontSize: "20px",
            border: "2px solid #f79c16",
            backgroundColor: "#85ce33",
          }}
          sx={{ width: 40, height: 40 }}
        >
          {displayName
            ? displayName.split(" ")[0]?.[0] + displayName.split(" ")[1]?.[0]
            : email?.substring(0, 2)?.toUpperCase() || "BB"}
        </Avatar>
        <div className={`dropdown-content ${menuOpen ? "active" : ""}`}>
          {options.map((option, index) => (
            <p key={index} onClick={option.clickHandler}>
              {option.name}
            </p>
          ))}
        </div>
      </div>
    </StyledOptions>
  );
}

const StyledOptions = styled.div`
  padding: 4px 8px;
  .dropdown-content {
    display: none;
    position: absolute;
    right: 5%;
    background-color: #f1f1f1;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    border-radius: 8px;
    padding: 6px;
    p {
      cursor: pointer;
      margin: 6px 0;
      font-weight: 500;
      font-family: "Poppins";
      display: flex;
      align-items: center;
      gap: 10px;
      height: 26px;
      &:hover {
        color: var(--primary-color);
      }
    }
  }
  .active {
    display: block;
  }
`;
